import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { heatDataNew } from "../../data/heatData"

const Holder = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  color: white;

  p {
    margin: 0 0 0.25rem 0;
    font-size: 0.4rem;
    line-height: 0.8rem;
    font-weight: 500;

    span {
      color: #F1A29F;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 0 0.4rem;
      margin: 0 0.125rem;
      height: 0.8rem;
      background: deeppink;
      border-top-right-radius: 0.4rem;
      border-bottom-left-radius: 0.4rem;
    }

    .title {
      background: #ffde7c;
    }

    .heat {
      background: #a5ff90;
    }

    .visibility {
      background: #d574ff;
    }

    .rain {
      background: #90ffd8;
    }

    .air {
      background: #ff70b0;
    }

    .quarter {
      color: #F1E1B5;
      background: #ff8a87;
    }
  }

  .top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0.5rem;
    text-align: center;
  }

  .bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0.5rem;
    text-align: center;
  }
`

function Labels() {
  const [labelIndex, setLabelIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      if (labelIndex === heatDataNew.length - 1) {
        setLabelIndex(0)
        return
      }
      setLabelIndex(labelIndex + 1)
    }, 8000)
    return () => clearInterval(interval)
  })

  return (
    <Holder>
      <div className="top">
        <p><span className="title">City of Parramatta</span></p>
        <p>
          <span className="heat">Heat</span>
          <span className="visibility">Visibility</span>
          <span className="rain">Rain</span>
          <span className="air">Air Quality</span>
        </p>
      </div>
      <div className="bottom">
        <p><span className="quarter">{heatDataNew[labelIndex].quarter}</span></p>
      </div>
    </Holder>
  )
}

export default Labels
